import { render, staticRenderFns } from "./Members.vue?vue&type=template&id=4d4e3210&scoped=true&lang=pug&"
import script from "./Members.vue?vue&type=script&lang=ts&"
export * from "./Members.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4e3210",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/arc-one/_www/millsta-ready/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d4e3210')) {
      api.createRecord('4d4e3210', component.options)
    } else {
      api.reload('4d4e3210', component.options)
    }
    module.hot.accept("./Members.vue?vue&type=template&id=4d4e3210&scoped=true&lang=pug&", function () {
      api.rerender('4d4e3210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/templates/Members.vue"
export default component.exports